module.exports = __webpack_public_path__ + "img/shopping_application_3.34babfd1.jpg";